import type { PropsWithChildren } from "react"
import Link from "next/link"
import {
  FacebookIcon,
  InstagramIcon,
  LinkedInIcon,
  TwitterIcon,
  YouTubeIcon,
  MastodonIcon,
  TikTokIcon,
  WhatsAppIcon,
} from "common/components/icons/social"

interface SocialMediaLinkProps {
  icon: string
  href: string
  title?: string
}

interface SocialMediaIconProps {
  icon: string
}

const SocialMediaIcon = ({ icon }: PropsWithChildren<SocialMediaIconProps>) => {
  switch (icon) {
    case "facebook":
      return (
        <div className="group flex h-14 w-14 rounded-full bg-white hover:bg-facebook lg:h-11 lg:w-11">
          <FacebookIcon className="m-auto h-5 w-5 fill-facebook group-hover:fill-white lg:h-4 lg:w-4" />
        </div>
      )
    case "twitter":
      return (
        <div className="group flex h-14 w-14 rounded-full bg-white hover:bg-twitter lg:h-11 lg:w-11">
          <TwitterIcon className="m-auto h-5 w-5 fill-twitter group-hover:fill-white lg:h-4 lg:w-4" />
        </div>
      )
    case "instagram":
      return (
        <div className="group flex h-14 w-14 rounded-full bg-white hover:bg-instagram lg:h-11 lg:w-11">
          <InstagramIcon className="m-auto h-5 w-5 fill-instagram group-hover:fill-white lg:h-4 lg:w-4" />
        </div>
      )
    case "linkedin":
      return (
        <div className="group flex h-14 w-14 rounded-full bg-white hover:bg-linkedin lg:h-11 lg:w-11">
          <LinkedInIcon className="m-auto h-5 w-5 fill-linkedin group-hover:fill-white lg:h-4 lg:w-4" />
        </div>
      )
    case "youtube":
      return (
        <div className="group flex h-14 w-14 rounded-full bg-white hover:bg-youtube lg:h-11 lg:w-11">
          <YouTubeIcon className="m-auto h-5 w-5 fill-youtube group-hover:fill-white lg:h-4 lg:w-4" />
        </div>
      )
    case "mastodon":
      return (
        <div className="group flex h-14 w-14 rounded-full bg-white hover:bg-mastodon lg:h-11 lg:w-11">
          <MastodonIcon className="m-auto h-5 w-5 fill-mastodon group-hover:fill-white lg:h-4 lg:w-4" />
        </div>
      )
    case "tiktok":
      return (
        <div className="group flex h-14 w-14 rounded-full bg-white hover:bg-black lg:h-11 lg:w-11">
          <TikTokIcon className="m-auto h-5 w-5 fill-black group-hover:fill-white lg:h-4 lg:w-4" />
        </div>
      )
    case "whatsapp":
      return (
        <div className="group flex h-14 w-14 rounded-full bg-white hover:bg-whatsapp lg:h-11 lg:w-11">
          <WhatsAppIcon className="m-auto h-5 w-5 fill-whatsapp group-hover:fill-white lg:h-4 lg:w-4" />
        </div>
      )
    default:
      return null
  }
}

export const SocialMediaLink = ({ icon, title, href }: PropsWithChildren<SocialMediaLinkProps>) => {
  return (
    <Link href={href} title={title} rel="me">
      <SocialMediaIcon icon={icon} />
    </Link>
  )
}
